import React, { useRef } from "react";
import { StaticLayoutRenderer } from "components/Topology/staticLayer/StaticLayoutRenderer";
import {
  useComputedTopologyLayout,
  useSelectedTopologyItemId,
} from "objs/_ConfiguratorObjs/Wizard/stores/wizardStore";
import { InteractiveLayer } from "./interactiveLayer/InteractiveLayer";

export const Topology = React.memo(
  ({ transformState, viewportRef, isPrint = false }) => {
    const wrapperRef = useRef(null);
    const selectedId = useSelectedTopologyItemId();
    const layout = useComputedTopologyLayout();

    if (!layout) {
      return null;
    }

    return (
      <div
        ref={wrapperRef}
        style={{
          position: "relative",
          width: `${layout.width}px`,
          height: `${layout.height}px`,
        }}
      >
        {!isPrint && layout?.interactiveElementsArr.length > 0 && (
          <InteractiveLayer
            layout={layout}
            transformState={transformState}
            viewportRef={viewportRef}
            selectedId={selectedId}
          />
        )}
        <StaticLayoutRenderer layout={layout} isPrint={isPrint} />
      </div>
    );
  },
);
